import { useCallback, useContext, useState } from 'react';

import { ApiContext, CoreContext, FirebaseContext } from '../../providers';
import { clearUserData } from '../../state';

export const useFirebaseAuth = () => {
    const [authLoading, setAuthLoading] = useState<boolean>(false);

    const { store } = useContext(CoreContext);
    const { user, userSignOut } = useContext(FirebaseContext);
    const { getRequestID } = useContext(ApiContext);

    const clearAllUserData = async () => {
        store.dispatch(clearUserData());
        return await getRequestID();
        ``;
    };

    const handleSignOutCurrentUser = useCallback(async () => {
        await userSignOut();

        /** We are resetting the redux state to its initial value */
        await clearAllUserData();
    }, []);

    return {
        currentUser: user,
        handleSignOutCurrentUser,
        authLoading,
        setAuthLoading,
    };
};
